var React = require('react');

function BannerTopInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M661.5 11.1363C426.3 -17.6637 121.833 16.1363 -1 36.6363V60.6364H1440V16.6364C1185 42.6364 955.5 47.1363 661.5 11.1363Z","fill":"#DD3F45"}));
}

BannerTopInline.defaultProps = {"width":"1440","height":"61","viewBox":"0 0 1440 61","fill":"none"};

module.exports = BannerTopInline;

BannerTopInline.default = BannerTopInline;
